import { Button } from 'blaze-ui/Button'
import { ArrowRefresh2 } from 'blaze-ui/icons'
import { Text } from 'blaze-ui/Text/Text'
import Styles from 'components/Wizards/BlogPostWizard/BlogPostWizard.module.scss'
import React from 'react'

type Props = { retry: () => void }

export const LinkGenerationError = ({ retry }: Props): React.ReactElement => {
  return (
    <div className={Styles.errorContainer}>
      <Text color="var(--dark-100)">
        <div>Oops, something went wrong while generating links. Please try again.</div>
        <div className={Styles.tryAgainButton}>
          <Button onPress={retry} variant="secondary" frontIcon={ArrowRefresh2}>
            Try Again
          </Button>
        </div>
      </Text>
    </div>
  )
}
